module.exports = __webpack_public_path__ + "static/media/under_construction_image.06ed72f4.jpg";